import i18n from '@/i18n'; /*
 * @Author: TigerLord
 * @Date: 2022-09-21 11:06:34
 * @LastEditTime: 2022-10-28 14:12:05
 * @LastEditors: your name
 * @Description: 功能说明：——
 * @FilePath: /ytzx-console/src/pages/system/ContentModeration/index.ts
 */
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('ContentModeration-index-1992f2b88fc568936-1'),
    routerUrl: '/ContentModeration',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./ContentModeration')),
    children: [
      //$MORE$
    ],
  },
];
